'use strict';
import angular from 'angular';

export default class AppGalleryController {
    /*@ngInject*/
    constructor($stateParams, $http, $state, Application, $scope, Upload, fileReader) {
        var vm = this;

        //$('.bslider').bootstrapSlider();

        vm.fileUploadTime = Date.now();

        $http.get('/api/applications/' + $stateParams.id).then(
            function (res) {
                var data = res.data;
                Application.load($stateParams.id).then(function () {
                    $scope.$apply(function () {
                        vm.app = Application;
                    });

                });

            }, function (error) {
                if (error.status == "404") {
                    $state.go('application_main');
                }
                console.log(error);
            });


        $http.get('/api/applications/' + $stateParams.id + '/galleryId').then(
            function (res) {
                var data = res.data;
                vm.galleryId = data._id;

                $http.get('/api/galleries/' + vm.galleryId + '').then(
                    function (res) {
                        var data = res.data;
                        vm.gallery = data;
                    }, function (error) {
                        console.log(error);
                    });

            }, function (error) {
                console.log(error);
            });


        vm.save = function () {
            Application.save($stateParams.id);
        }

        vm.next = function () {
            Application.save($stateParams.id);
            $state.go('application_main');
        }

        vm.upload = function (file) {
            Upload.upload({
                url: '/api/galleries/' + vm.galleryId + '/upload',
                data: { file: $scope.pictures }
            }).then(function (resp) {
                console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
                vm.fileUploadTime = Date.now();
            }, function (resp) {
                console.log('Error status: ' + resp.status);
            }, function (evt) {
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            });
        };


        $scope.pictures = [];
        $scope.srcPictures = [];

        $scope.addFiles = function (files) {
            if (files && files.length) {
                _.each(files, function (file) {
                    $scope.pictures.push(file);
                    $scope.srcPictures.push({ name: file.name, src: '' });
                    fileReader.readAsDataUrl(file, $scope, $scope.srcPictures.length - 1)
                        .then(function (result) {
                            console.log(result.id);
                            $scope.srcPictures[result.id].src = result.src;

                        });
                });
                console.log(files);
            }
        }


    }

}


// WEBPACK FOOTER //
// ./client/app/application/gallery/gallery.controller.js